"use strict";

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiskValidationError = exports.convertErrorsToLegacyFormat = void 0;

var errorParamToString = function errorParamToString(param) {
  var paramAsString = '';

  if (typeof param === 'bigint') {
    paramAsString = param.toString();
  } else if (Buffer.isBuffer(param)) {
    paramAsString = param.toString('hex');
  } else if (param === undefined) {
    paramAsString = '';
  } else {
    paramAsString = param;
  }

  return paramAsString;
};

var convertErrorsToLegacyFormat = function convertErrorsToLegacyFormat(errors) {
  return errors.map(function (e) {
    var _a, _b;

    var err = e;
    err.dataPath = (_a = err.dataPath) !== null && _a !== void 0 ? _a : instancePathToLegacyDataPath((_b = err.instancePath) !== null && _b !== void 0 ? _b : '');
    delete err.instancePath;
    return err;
  });
};

exports.convertErrorsToLegacyFormat = convertErrorsToLegacyFormat;

var instancePathToLegacyDataPath = function instancePathToLegacyDataPath(path) {
  return path.split('/').join('.');
};

var errorFormatterMap = {
  type: function type(error) {
    var _a;

    return "Property '".concat((_a = error.dataPath) !== null && _a !== void 0 ? _a : '', "' should be of type '").concat(errorParamToString(error.params.type), "'");
  },
  additionalProperties: function additionalProperties(error) {
    var _a;

    return "Property '".concat((_a = error.dataPath) !== null && _a !== void 0 ? _a : '', "' has extraneous property '").concat(errorParamToString(error.params.additionalProperty), "'");
  },
  minLength: function minLength(error) {
    var _a;

    return "Property '".concat((_a = error.dataPath) !== null && _a !== void 0 ? _a : '', "' ").concat(errorParamToString(error.message));
  },
  maxLength: function maxLength(error) {
    var _a;

    return "Property '".concat((_a = error.dataPath) !== null && _a !== void 0 ? _a : '', "' ").concat(errorParamToString(error.message));
  },
  format: function format(error) {
    var _a;

    return "Property '".concat((_a = error.dataPath) !== null && _a !== void 0 ? _a : '', "' ").concat(errorParamToString(error.message));
  },
  required: function required(error) {
    return "Missing property, ".concat(errorParamToString(error.message));
  },
  dataType: function dataType(error) {
    var _a;

    return "Property '".concat((_a = error.dataPath) !== null && _a !== void 0 ? _a : '', "' ").concat(errorParamToString(error.message));
  }
};

var defaultErrorFormatter = function defaultErrorFormatter(error) {
  var _a;

  return (_a = error.message) !== null && _a !== void 0 ? _a : 'Unspecified validator error';
};

var errorFormatter = function errorFormatter(error) {
  var _a;

  return ((_a = errorFormatterMap[error.keyword]) !== null && _a !== void 0 ? _a : defaultErrorFormatter)(error);
};

var LiskValidationError = /*#__PURE__*/function (_Error) {
  _inherits(LiskValidationError, _Error);

  function LiskValidationError(errors) {
    var _this;

    _classCallCheck(this, LiskValidationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LiskValidationError).call(this));
    _this.errors = exports.convertErrorsToLegacyFormat(errors);
    _this.message = "Lisk validator found ".concat(_this.errors.length, " error[s]:\n").concat(_this._compileErrors().join('\n'));
    return _this;
  }

  _createClass(LiskValidationError, [{
    key: "_compileErrors",
    value: function _compileErrors() {
      var errorMsgs = this.errors.map(errorFormatter);
      return errorMsgs;
    }
  }]);

  return LiskValidationError;
}(_wrapNativeSuper(Error));

exports.LiskValidationError = LiskValidationError;